import { types } from "../action-types";

const initialState = {
  loading: false,
  all: {
    members: [],
    totalCount: 0,
  },
  error: false,

  AddMemberloading: false,
  success: false,
  response: [],
  deleteMemberLoading: false,
  deleteMemberSuccess: false,
  deleteMemberResponse: [],
};

const getFirstArray = (payload) => {
  if (Array.isArray(payload)) return payload;

  const isTeamMemberObject = (item) =>
    Boolean(
      item?.id ||
      item?.invitationId ||
      item?._id ||
      item?.EmailAddress ||
      item?.emailAddress
    );

  const arrayKeys = [
    "members",
    "teamMembers",
    "TeamMembers",
    "All",
    "all",
    "data",
    "items",
    "rows",
    "result",
    "results",
  ];

  for (const key of arrayKeys) {
    if (Array.isArray(payload?.[key])) return payload[key];
    if (payload?.[key] && typeof payload[key] === "object") {
      const nested = getFirstArray(payload[key]);
      if (nested.length) return nested;
    }
  }

  return isTeamMemberObject(payload) ? [payload] : [];
};

const getNormalizedInvitationId = (member) => {

  const invitationId = member?.invitationId || member?.InvitationId;
  if (invitationId !== undefined && invitationId !== null && invitationId !== "") {
    return invitationId;
  }

  const status = String(member?.status || member?.Status || "").toLowerCase();
  const isPending =
    status === "pending" ||
    member?.isPending === true ||
    member?.IsPending === true;

  return isPending ? member?.id ?? member?._id : invitationId;
};

const normalizeTeamMember = (member) => {
  if (!member || typeof member !== "object" || Array.isArray(member)) {
    return member;
  }

  const invitationId = getNormalizedInvitationId(member);

  return {
    ...member,
    invitationId,
  };
};

const getTotalCount = (payload, members) => {
  const total =
    payload?.totalCount ??
    payload?.totalMembers ??
    payload?.total ??
    payload?.count ??
    payload?.pagination?.totalCount ??
    payload?.pagination?.total ??
    payload?.meta?.totalCount ??
    payload?.meta?.total;

  return Number.isFinite(Number(total)) ? Number(total) : members.length;
};

const TeamMembersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_TEAM_REQUESTED:
      return {
        ...state,
        loading: true,
        all: {
          ...state.all,
          members: [],
        },
      };

    case types.GET_ALL_TEAM_SUCCESS: {
      const members = getFirstArray(action.payload).map(normalizeTeamMember);
      return {
        ...state,
        loading: false,
        all: {
          members,
          totalCount: getTotalCount(action.payload, members),
        },
        error: false,
      };
    }
    case types.GET_ALL_TEAM_FAILURE:
      return {
        ...state,
        loading: false,
        all: {
          members: [],
          totalCount: 0,
        },
        error: true,
      };
  

    case types.ADD_TEAM_REQUESTED:
      return {
        ...state,
        AddMemberloading: true,
        success: false,
      };

    case types.ADD_TEAM_SUCCESS:
      return {
        ...state,
        AddMemberloading: false,
        success: true,
        error: false,
        response: action.payload,
      };

    case types.ADD_TEAM_FAILURE:
      return {
        ...state,
        AddMemberloading: false,
        success: false,
        error: true,
        response: action.payload.message,
      };
    case types.ADD_TEAM_RESET:
      return {
        ...state,
        AddMemberloading: false,
        success: false,
        error: false,
        response: [],
      };

    case types.DELETE_TEAM_REQUESTED:
      return {
        ...state,
        deleteMemberLoading: true,
        deleteMemberSuccess: false,
        deleteMemberResponse: [],
      };

    case types.DELETE_TEAM_SUCCESS:
      return {
        ...state,
        deleteMemberLoading: false,
        deleteMemberSuccess: true,
        error: false,
        deleteMemberResponse: action.payload,
      };

    case types.DELETE_TEAM_FAILURE:
      return {
        ...state,
        deleteMemberLoading: false,
        deleteMemberSuccess: false,
        error: true,
        deleteMemberResponse: action.payload,
      };

    case types.DELETE_TEAM_RESET:
      return {
        ...state,
        deleteMemberLoading: false,
        deleteMemberSuccess: false,
        error: false,
        deleteMemberResponse: [],
      };
    default:
      return state;
  }
};

export default TeamMembersReducer;
